module.exports = __webpack_public_path__ + "img/required.0631c263.svg";